export default __webpack_public_path__ + "static/media/Edit.251faea5.svg";